type GenerateDestinationURLParams = {
  configurationCode: string;
  leadChannelCode: string;
  originalURL: string;
  prodOverride?: string;
  stageOverride?: string;
  uniqueIdentifier?: string;
};

export type GenerateDestinationURLWithMode = (
  params: GenerateDestinationURLParams,
) => string;

export const generateDestinationURL =
  (mode: string): GenerateDestinationURLWithMode =>
  ({
    configurationCode,
    leadChannelCode,
    originalURL,
    prodOverride,
    stageOverride,
    uniqueIdentifier,
  }: GenerateDestinationURLParams): string => {
    let baseURL = originalURL;

    if (mode === 'production' && prodOverride) {
      baseURL = prodOverride;
    } else if (mode !== 'production' && stageOverride) {
      baseURL = stageOverride;
    }

    if (!baseURL) {
      return '';
    }

    const url = new URL(baseURL);

    // for reporting, this will be included in metadata submitted from FastTrack
    url.searchParams.set('configurationCode', configurationCode);

    // for FastTrack
    url.searchParams.set('leadChannel', leadChannelCode);

    // for Consumer Portal
    url.searchParams.set('leadChannelCode', leadChannelCode);

    if (uniqueIdentifier) {
      // for FastTrack
      url.searchParams.set(
        'ap[a][partnerRecordUniqueIdentifier]',
        uniqueIdentifier,
      );

      // for Consumer Portal
      url.searchParams.set('partnerRecordUniqueIdentifier', uniqueIdentifier);
    }

    return url.toString();
  };
